import FileAttachmentGroup, {
	FileAttachmentGroupProps,
} from '@/components/Attachment/FileAttachmentGroup'
import {
	AttachmentType,
	type Attachment,
	type FileAttachment as FileAttachmentType,
	type LinkAttachment as LinkAttachmentType,
} from '@/states/attachment'
import { css } from '@emotion/react'
import { first, isEmpty } from 'lodash-es'
import { AnimatePresence } from 'motion/react'
import LinkAttachment, { LinkAttachmentProps } from './LinkAttachment'

export interface AttachmentsPreviewProps extends Omit<FileAttachmentGroupProps, 'data'> {
	data: Attachment[]
}

/**
 * 附件预览组件
 * 需要在 FormProvider 之内使用
 */
export default function AttachmentsPreview({
	data,
	onDelete,
	onSwap,
	...props
}: AttachmentsPreviewProps) {
	const renderAttachments = () => {
		if (isEmpty(data)) {
			return null
		}

		if (first(data)?.type === AttachmentType.LINK) {
			const maybeFileAttachmentData = first(data) as LinkAttachmentType

			return (
				<LinkAttachment
					{...(props as LinkAttachmentProps)}
					css={css`
						margin-top: 16px;
					`}
					data={maybeFileAttachmentData}
					onDelete={() => onDelete?.(maybeFileAttachmentData.id)}
				/>
			)
		}

		return (
			<FileAttachmentGroup
				{...(props as FileAttachmentGroupProps)}
				css={css`
					padding-top: 16px;
				`}
				data={data as FileAttachmentType[]}
				onDelete={onDelete}
				onSwap={onSwap}
			/>
		)
	}

	return <AnimatePresence>{renderAttachments()}</AnimatePresence>
}
